import { Fragment } from "react";
import AddedList from "../../components/added-list/added-list.component";

const MyAnimeList = () => {
  return (
    <Fragment>
      <AddedList />
    </Fragment>
  );
};

export default MyAnimeList;
